import {
  Component,
  EventEmitter,
  inject,
  Input,
  input,
  OnInit,
  Output,
} from '@angular/core';
import {
  Candidatura,
  EstadoCandidaturaEnum,
  ExperienciaProfissional,
  HabilitacaoAcademica,
} from '@app/features-modules/bolsa-de-profissionais/api';
import {
  CandidaturaService,
  HabilitacaoAcademicaService,
  ExperienciaProfissionalService,
  EmpresaSectorService
} from '@app/features-modules/bolsa-de-profissionais/services';
import { Button } from 'primeng/button';
import { TabsModule } from 'primeng/tabs';
import { SplitButton } from 'primeng/splitbutton';
import { ConfirmationService, MenuItem, MessageService } from 'primeng/api';
import { ConfirmDialog } from 'primeng/confirmdialog';
import { CommonModule } from '@angular/common';
import { TagModule } from 'primeng/tag';
import { ToastModule } from 'primeng/toast';
import { ActivatedRoute } from '@angular/router';
import { TimelineModule } from 'primeng/timeline';
import { AvatarModule } from 'primeng/avatar';
import { getInitials } from '@app/shared/pipes/initials.pipe';
import { DocumentoPreviewModalComponent } from '@app/shared/components/documento-preview-modal/documento-preview-modal.component';
import { AnexoCandidaturaDto } from '@app/features-modules/gestao-de-concurso/core/documentos-candidatura.models';
import { labelTipoAnexoProfissional } from '@app/features-modules/bolsa-de-profissionais/api/model/anexo-candidatura-custom.model';

@Component({
  selector: 'app-candidatura-detalhe',
  imports: [
    CommonModule,
    Button,
    TabsModule,
    SplitButton,
    ToastModule,
    ConfirmDialog,
    TagModule,
    TimelineModule,
    AvatarModule,
    DocumentoPreviewModalComponent,
  ],
  providers: [ConfirmationService, MessageService, EmpresaSectorService],
  templateUrl: './candidatura-detalhe.component.html',
  styleUrl: './candidatura-detalhe.component.scss',
})
export class CandidaturaDetalheComponent implements OnInit {
  @Output() onCloseModal = new EventEmitter<boolean>();
  candidatura = input<any>();
  @Input() vagaDetail: any;
  candidaturaStory: any;
  candidaturaData: any;
  imageError = false;
  getInitials = getInitials;
  experienciaService = inject(ExperienciaProfissionalService);
  messageService = inject(MessageService);
  confirmationService = inject(ConfirmationService);
  candidaturaService = inject(CandidaturaService);
  empresaSecorService = inject(EmpresaSectorService);
  habilitacaoService = inject(HabilitacaoAcademicaService);
  route = inject(ActivatedRoute);

  listaHabilitacoes: HabilitacaoAcademica[] = [];
  listaExperiencias: ExperienciaProfissional[] = [];

  empresaID: number | null = null;
  empresaLogoUrl: string | null = null;
  DescEstadoVaga = '';

  labelButton = 'Aprovar';
  CheckVisibility = true;
  items: MenuItem[] = [];

  mostrarPreview = false;
  indicePreview = 0;
  anexosParaPreview: AnexoCandidaturaDto[] = [];

  get listaAnexos(): any[] {
    return this.candidaturaData?.anexoCandidaturas || this.candidatura()?.anexoCandidaturas || [];
  }

  get codigoLegivel(): string {
    return this.candidaturaData?.codigo || this.candidatura()?.codigo || '—';
  }

  get anosExperiencia(): number | null {
    const exp = this.candidaturaData?.anoExperiencia ?? this.candidatura()?.anoExperiencia;
    return exp !== undefined && exp !== null ? Number(exp) : null;
  }

  get cartaApresentacao(): string {
    return this.candidaturaData?.cartaApresentacao || this.candidatura()?.cartaApresentacao || '';
  }

  get candidaturaRemovida(): boolean {
    return !!(this.candidaturaData?.removerCandidatura || this.candidatura()?.removerCandidatura);
  }

  get motivoRemocao(): string {
    return this.candidaturaData?.motivoRemoverCandidatura || this.candidatura()?.motivoRemoverCandidatura || '';
  }

  rotuloTipoAnexo(tipoEnum: number | string): string {
    return labelTipoAnexoProfissional(tipoEnum);
  }

  get documentosEmFalta(): { id?: number; enumVal?: number; rotulo: string }[] {
    const tiposExigidos = this.vagaDetail?.vagaTipoAnexoCandidaturas ||
                          this.vagaDetail?.vagaTipoAnexoCandidatura ||
                          this.candidaturaData?.vaga?.vagaTipoAnexoCandidaturas || [];
    if (!Array.isArray(tiposExigidos) || tiposExigidos.length === 0) {
      return [];
    }
    const anexosSubmetidos = this.listaAnexos;
    const enumsSubmetidos = new Set(
      anexosSubmetidos.map((a: any) => Number(a.tipoAnexoCandidaturaEnum))
    );
    const vinculosSubmetidos = new Set(
      anexosSubmetidos.map((a: any) => Number(a.vagaTipoAnexoCandidaturaId))
    );

    return tiposExigidos
      .filter((t: any) => {
        const enumVal = Number(t.tipoAnexoCandidaturaEnum);
        const idVal = Number(t.id);
        const temPorEnum = !isNaN(enumVal) && enumsSubmetidos.has(enumVal);
        const temPorId = !isNaN(idVal) && vinculosSubmetidos.has(idVal);
        return !temPorEnum && !temPorId;
      })
      .map((t: any) => ({
        id: t.id,
        enumVal: t.tipoAnexoCandidaturaEnum,
        rotulo: t.tipoAnexoCandidatura || this.rotuloTipoAnexo(t.tipoAnexoCandidaturaEnum) || `Tipo ${t.tipoAnexoCandidaturaEnum}`,
      }));
  }

  abrirPreview(anexo: any, index: number): void {
    this.anexosParaPreview = (this.listaAnexos || []).map((a: any) => ({
      id: String(a.id ?? a.anexoId ?? Math.random()),
      nomeFicheiro: a.nomeFicheiro || a.tipoAnexoCandidaturaDescricao || this.rotuloTipoAnexo(a.tipoAnexoCandidaturaEnum) || 'Documento',
      mimeType: a.mimeType || (a.extensao === '.pdf' ? 'application/pdf' : (a.extensao === '.png' || a.extensao === '.jpg' || a.extensao === '.jpeg' ? 'image/jpeg' : 'application/octet-stream')),
      extensao: a.extensao,
      urlPreview: a.urlPreview || a.linkAnexoPreview,
      tipoDocumento: a.tipoAnexoCandidaturaDescricao || this.rotuloTipoAnexo(a.tipoAnexoCandidaturaEnum),
      tamanho: a.tamanho ?? 0,
      createdAt: a.dataCadastro,
    }));
    this.indicePreview = index;
    this.mostrarPreview = true;
  }

  ngOnInit() {
    this.candidaturaService.show(this.candidatura().id).subscribe((response) => {
      this.candidaturaData = response.data;
    });

    this.empresaSecorService.getPhotoEmpresaIdGet(this.candidatura().empresaID).subscribe(
      (blob: Blob) => {
        if (blob) {
          this.empresaLogoUrl = URL.createObjectURL(blob);
        }
      },
      () => {
        this.empresaLogoUrl = null;
      }
    );

    this.getExperiencias();
    this.getHabilitacoes();
    this.GetStory(this.candidatura().id);
    this.atualizarLabelsPorEstado();
  }

  closeModal() {
    this.onCloseModal.emit(true);
  }

  atualizarLabelsPorEstado() {
    const estado = this.candidatura()?.estadoCandidatura;

    this.CheckVisibility = estado !== 'Contratado ';

    switch (estado) {
      case 'Não Candidatado': // Não Candidatado
        this.labelButton = 'Enviar para Análise';
        this.items = [];
        break;

      case 'Em Análise': // Em Análise
        this.labelButton = 'Aprovar';
        this.items = [
          {
            label: 'Não Aprovar',
            command: () => this.naoAprovarCandidatura(),
          },
        ];
        break;

      case 'Aprovado': // Aprovado
        this.labelButton = 'Contratar';
        this.items = [
          {
            label: 'Não Contratar',
            command: () => this.naoContratarCandidatura(),
          },
        ];
        break;

      case 'Não Aprovado': // Não Aprovado
        this.labelButton = 'Reavaliar';
        this.items = [
          {
            label: 'Aprovar',
            command: () => this.aprovarCandidatura(),
          },
        ];
        break;

      case 'Não Contratado': // Não Contratado
        this.labelButton = 'Contratar';
        this.items = [
          {
            label: 'Contratar',
            command: () => this.ContratarCandidato(),
          },
        ];
        break;

      case 'Contratado ': // Contratado
        // já tratado com CheckVisibility
        this.CheckVisibility = false;
        break;

      default:
        this.labelButton = 'Aprovar';
        this.items = [];
        break;
    }
  }

  ToggleStatusCandidatura() {
    const estado = this.candidatura()?.estadoCandidatura;

    switch (estado) {
      case 'Submetida':
        this.aprovarCandidatura();
        break;

      case 'Aprovado':
        this.ContratarCandidato();
        break;

      case 'Não Aprovado':
        this.aprovarCandidatura();
        break;

      case 'Não Contratado':
        this.ContratarCandidato();
        break;

      case 'Contratado':
        this.labelButton = '',
          this.CheckVisibility = false;
        break;

      default:
        break;
    }
  }

  enviarParaAnalise() {
    this.confirmationService.confirm({
      header: 'Enviar para análise?',
      message: `Deseja enviar a candidatura de ${this.candidatura()?.profissional?.nome} para análise?`,
      accept: () =>
        this.updateEstadoCandicatura(EstadoCandidaturaEnum.NUMBER_1),
      reject: () => {
        this.messageService.add({
          severity: 'info',
          summary: 'Cancelado',
          detail: 'Ação cancelada.',
        });
      },
    });
  }

  updateEstadoCandicatura(estado: EstadoCandidaturaEnum) {
    let candidaturaUp = {
      id: this.candidaturaData.id,
      profissionalID: this.candidaturaData.profissionalID,
      vagaID: this.candidaturaData.vagaID,
      estadoCandidatura: estado,
    };

    this.candidaturaService.update(candidaturaUp).subscribe((result) => {
      if (result.retorno?.codigo === 200) {
        this.messageService.add({
          severity: 'success',
          summary: 'Actualizada',
          detail: 'A sua candidatura foi actualizada com sucesso.',
          life: 3000,
        });
        this.atualizarLabelsPorEstado();
        setTimeout(() => {
          this.onCloseModal.emit(true);
        }, 1000);
        return;
      }

      if (result.retorno?.codigo === 400) {
        this.messageService.add({
          severity: 'error',
          summary: 'Erro na candidatura',
          detail: `${result.retorno.mensagem}`,
        });
        return;
      }

      this.messageService.add({
        severity: 'error',
        summary: 'Erro na candidatura',
        detail: 'Ocorreu um erro ao submeter a sua candidatura. Por favor, tente novamente.',
      });
    });
  }


  aprovarCandidatura() {
    this.confirmationService.confirm({
      header: 'Confirmar Candidatura?',
      message: `A candidatura do profissional ${this.candidatura()?.profissional?.nome} para a vaga ${this.candidatura()?.vaga?.designacaoFuncao || this.vagaDetail?.designacaoFuncao || ''} será aprovada. Deseja continuar?`,
      accept: () => this.updateEstadoCandicatura(EstadoCandidaturaEnum.NUMBER_4),
      reject: () => {
        this.messageService.add({
          severity: 'info',
          summary: 'Cancelada',
          detail: 'Candidatura cancelada',
        });
      },
    });
  }

  // rejeitarCandidatura() {
  //   this.confirmationService.confirm({
  //     header: 'Rejeitar Candidatura?',
  //     message: `A candidatura do profissional ${this.candidatura()?.profissional?.nome} para a vaga ${this.candidatura()?.vaga?.designacaoFuncao || this.vagaDetail?.designacaoFuncao || ''} será rejeitada. Deseja continuar?`,
  //     accept: () => this.updateEstadoCandicatura(EstadoCandidaturaEnum.NUMBER_5),
  //     reject: () => {
  //       this.messageService.add({
  //         severity: 'info',
  //         summary: 'Cancelada',
  //         detail: 'Candidatura cancelada',
  //       });
  //     },
  //   });
  // }

  naoAprovarCandidatura() {
    this.confirmationService.confirm({
      header: 'Não Aprovar Candidatura?',
      message: `Tem certeza que deseja não aprovar esta candidatura?`,
      accept: () => this.updateEstadoCandicatura(EstadoCandidaturaEnum.NUMBER_5),
      reject: () => {
        this.messageService.add({
          severity: 'info',
          summary: 'Cancelado',
          detail: 'Ação cancelada.',
        });
      },
    });
  }

  naoContratarCandidatura() {
    this.confirmationService.confirm({
      header: 'Não Contratar?',
      message: `Deseja marcar o candidato como não contratado?`,
      accept: () => this.updateEstadoCandicatura(EstadoCandidaturaEnum.NUMBER_3),
      reject: () => {
        this.messageService.add({
          severity: 'info',
          summary: 'Cancelado',
          detail: 'Ação cancelada.',
        });
      },
    });
  }

  ContratarCandidato() {
    this.confirmationService.confirm({
      header: 'Confirmar contratação?',
      message: `O profissional ${this.candidatura()?.profissional?.nome} será contratado para a vaga ${this.candidatura()?.vaga?.designacaoFuncao || this.vagaDetail?.designacaoFuncao || ''}. Deseja continuar?`,
      accept: () => this.updateEstadoCandicatura(EstadoCandidaturaEnum.NUMBER_2),
      reject: () => {
        this.messageService.add({
          severity: 'info',
          summary: 'Cancelada',
          detail: 'Candidatura cancelada',
        });
      },
    });
  }

  getHabilitacoes() {
    const profissionalId = this.candidatura()?.profissional?.id;
    if (profissionalId !== undefined) {
      this.habilitacaoService
        .listByProfissionalId(profissionalId as any)
        .subscribe((result) => {
          if (result.retorno?.codigo === 200 && result.data) {
            this.listaHabilitacoes = result.data;
          }
        });
    }
  }

  getExperiencias() {
    const profissionalId = this.candidatura()?.profissional?.id;
    if (profissionalId !== undefined) {
      this.experienciaService
        .listByProfissionalId(profissionalId as any)
        .subscribe((result) => {
          if (result.retorno?.codigo === 200 && result.data) {
            this.listaExperiencias = result.data;
          }
        });
    }
  }

  GetStory(id: any) {
    this.candidaturaService.GetStory(id).subscribe((response) => {
      this.candidaturaStory = response.data;
    });
  }

  getSeverityVaga(estado: number): 'success' | 'danger' | 'warn' | 'info' {
    switch (estado) {
      case 1: // Aberto
        return 'success';
      case 2:
        return 'info';
      case 3:
        return 'danger';
      default:
        return 'warn';
    }
  }

  getSeverityCandidatura(estado: string): 'success' | 'danger' | 'warn' | 'info' {
    switch (estado) {
      case 'Não Candidatado':
        return 'danger';
      case 'Em Análise':
        return 'info';
      case 'Contratado':
        return 'success';
      case 'Não Contratado':
        return 'danger';
      case 'Aprovado':
        return 'warn';
      case 'Não Aprovado':
        return 'danger';
      case 'Submetida':
        return 'warn';
      default:
        return 'warn';
    }
  }
}
